import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import atob from 'atob';
import {
  Grid,
  Container,
  Segment,
  Header,
  Table,
  List,
  Popup,
  Label,
  Message,
  Form,
  TextArea,
  Button,
  Statistic,
} from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import { base, cloudFunctionsURL, firebaseAuth, REGEX_PATTERNS } from '../../../config/constants';
import { AlertBox, ConfirmBox, askConfirmation, setAlertMsg } from '../../../components/Modals/index';

const getUserLabelContent = (email) => {
  if (!email) {
    return (
      <Header
        content="Utilisateur anonyme"
        size="mini"
      />
    );
  }
  return (
    <Popup
      trigger={
        <span>
          {email.toUpperCase()}
        </span>
      }
    >
      <Popup.Content>{email}</Popup.Content>
    </Popup>
  );
};

const translateActionCode = (actionCode) => {
  switch (actionCode) {
    case 'must_create_profile':
      return 'OK / Habiliter l\'utilisateur (nouvel utilisateur)';
    case 'created_profile':
      return 'OK / Profil utilisateur créé, utilisateur habilité';
    case 'already_has_access_to_same_type':
      return `KO / L'utilisateur a déjà accès à une autre flux de ce type`;
    case 'must_update_profile':
      return 'OK / Habiliter l\'utilisateur (utilisateur existant)';
    case 'updated_profile':
      return 'OK / Profil utilisateur modifié, utilisateur habilité';
    case 'must_create_preregistration':
      return 'OK / Préinscrire cet utilisateur';
    case 'created_preregistration':
      return 'OK / Utilisateur préinscrit';
    case 'already_preregistered_to_same_type':
      return `KO / Utilisateur déjà préinscrit à une autre flux de ce type`;
    case 'must_update_preregistration':
      return 'OK / Mettre à jour de la préinscription';
    case 'updated_preregistration':
      return 'OK / Préinscription mise à jour';
    default:
      return '? / Erreur inconnue';
  }
};

const formatResults = results => (
  <Container>
    <Table basic compact="very">
      <Table.Body>
        {
          _.map(results, (r, k) => (
            <Table.Row positive={r.res} negative={!r.res} key={k}>
              <Table.Cell>{r.email}</Table.Cell>
              <Table.Cell>{translateActionCode(r.action)}</Table.Cell>
            </Table.Row>
          ))
        }
      </Table.Body>
    </Table>
  </Container>
);

export default class ListRecipients extends Component {
  static propTypes = {
    history: PropTypes.object,
    habilitations: PropTypes.object,
    themeId: PropTypes.string,
    themeName: PropTypes.string,
    themeType: PropTypes.string,
  }

  static defaultProps = {
    habilitations: { uid: null },
    history: null,
    themeId: null,
    themeName: '',
    themeType: 'themes',
  }

  constructor(props) {
    super(props);
    this.state = {
      recipients: [],
      preregistrations: [],
      listenersLoading: true,
      preregListenerLoading: true,
      verified: false,
      adding: false,
      lines: 1,
      emailBuffer: {
        goodToSend: [], // [string, string, ...]
        notGoodToSend: [], // [{line, value}]
      },
    };
    this.fields = { emailBlock: '' };
  }

  componentDidMount() {
    if (this.props.themeId) {
      this.selectedBinding = base.bindToState('users', {
        context: this,
        state: 'recipients',
        asArray: true,
        queries: {
          orderByChild: this.getCurrentObjectName(),
          equalTo: this.props.themeId,
        },
        then: () => this.setState({ listenersLoading: false }),
      });
      this.selectedPreregBinding = base.bindToState('preinscriptions', {
        context: this,
        state: 'preregistrations',
        asArray: true,
        queries: {
          orderByChild: this.props.themeType,
          equalTo: this.props.themeId,
        },
        then: () => this.setState({ preregListenerLoading: false }),
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.themeId !== this.props.themeId) {
      this.setState({ listenersLoading: true, preregListenerLoading: true });
      base.removeBinding(this.selectedBinding);
      base.removeBinding(this.selectedPreregBinding);
      if (nextProps.themeId) {
        this.selectedBinding = base.bindToState('users', {
          context: this,
          state: 'recipients',
          asArray: true,
          queries: {
            orderByChild: this.getCurrentObjectName(),
            equalTo: this.props.themeId,
          },
          then: () => this.setState({ preregListenerLoading: false }),
        });
      }
      if (nextProps.themeId) {
        this.selectedPreregBinding = base.bindToState('preinscriptions', {
          context: this,
          state: 'preinscriptions',
          asArray: true,
          queries: {
            orderByChild: this.props.themeType,
            equalTo: this.props.themeId,
          },
          then: () => this.setState({ preregListenerLoading: false }),
        });
      }
    }
  }

  getCurrentObjectName = () => {
    switch (this.props.themeType) {
      case 'themes':
        return 'currentTheme';
      case 'citizenly':
        return 'currentCitizenly';
      case 'elected':
        return 'currentElected';
      default:
        return 'currentTheme';
    }
  }

  getThemeTypeLabel = (cap = false, plural = false) => {
    switch (this.props.themeType) {
      case 'themes':
        return `${(cap ? 'P' : 'p')}rofession${(plural ? 's' : '')}`;
      case 'citizenly':
        return `${(cap ? 'C' : 'c')}ommune${(plural ? 's' : '')}`;
      case 'elected':
        return `${(cap ? 'C' : 'c')}irconscription${(plural ? 's' : '')}`;
      default:
        return '[THEME]';
    }
  }

  handleAddCheck = () => {
    const v = this.fields.emailBlock;
    const splitBlock = _.map(v.split('\n'), i => i.trim());
    const good = [];
    const notGood = [];
    _.forEach(splitBlock, (e, k) => {
      if (REGEX_PATTERNS.email.test(e)) {
        good.push(e);
      } else {
        notGood.push({ l: (k + 1), v: e });
      }
      // console.log(good, notGood);
    });
    this.setState({
      emailBuffer: {
        goodToSend: good,
        notGoodToSend: notGood,
      },
      verified: true,
    });
  }

  handleAddSubmit = () => {
    this.setState({ adding: true });
    const postData = {
      emails: this.state.emailBuffer.goodToSend,
      themeType: this.props.themeType,
      themeId: this.props.themeId,
      simulation: true,
    };
    firebaseAuth().currentUser.getIdToken(/* forceRefresh */ false)
      .then(idToken => fetch(`${cloudFunctionsURL}/massAddRecipients`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${idToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData),
      }).then(resp => resp.json()).then((data) => {
        console.log(data);
        // TODO : Resume here. Display result, ask for confirmation then handleAddReiterate.
        this.setState({
          ...askConfirmation(
            'Aperçu avant application de l\'ajout',
            formatResults(data.results),
            'neutral',
            () => this.handleAddReiterate(),
            'Appliquer',
          ),
          adding: false,
        });
      }))
      .catch(error => this.setState({
        ...setAlertMsg(error.code || null, 'Erreur lors de la transmission des données', error.toString(), 'error'),
        adding: false,
      }));
  }

  handleAddReiterate = () => {
    this.setState({ adding: true });
    const postData = {
      emails: this.state.emailBuffer.goodToSend,
      themeType: this.props.themeType,
      themeId: this.props.themeId,
      simulation: false,
    };
    firebaseAuth().currentUser.getIdToken(/* forceRefresh */ false)
      .then(idToken => fetch(`${cloudFunctionsURL}/massAddRecipients`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${idToken}`,
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postData),
      }).then(resp => resp.json()).then((data) => {
        console.log(data);
        // TODO : Resume here. Display result, ask for confirmation then handleAddReiterate.
        this.resetForm({
          ...setAlertMsg(
            null,
            'Résultat de l\'ajout',
            formatResults(data.results),
            'success',
          ),
          adding: false,
        });
      }))
      .catch(error => this.setState({
        ...setAlertMsg(error.code || null, 'Erreur lors de la transmission des données', error.toString(), 'error'),
        adding: false,
      }));
  }

  resetForm = (spreadMe = {}) => {
    // this.fields = { emailBlock: '' };
    this.setState({
      ...spreadMe,
      verified: false,
      adding: false,
      emailBuffer: {
        goodToSend: [],
        notGoodToSend: [],
      },
    });
  }

  selectedBinding;
  selectedPreregBinding;

  render() {
    const { goodToSend, notGoodToSend } = this.state.emailBuffer;
    const maxLines = 30;
    const nNon = _.filter(this.state.recipients, u => u.email).length;
    const nAnon = _.filter(this.state.recipients, u => !u.email).length;
    const nPrereg = this.state.preregistrations.length;

    return (
      <Container>
        <Segment basic loading={this.state.listenersLoading}>
          <Grid columns={2}>
            <Grid.Column>
              <Grid.Row>
                <Segment
                  textAlign="center"
                  attached
                  // inverted
                  // color="grey"
                  content={<Header content={this.props.themeName.toUpperCase()} />}
                />
                <Segment attached>
                  <Statistic.Group widths="three">
                    <Statistic color="green">
                      <Statistic.Value>
                        {nNon}
                      </Statistic.Value>
                      <Statistic.Label>
                        {
                          nNon > 1
                            ? 'Nominatifs' : 'Nominatif'
                        }
                      </Statistic.Label>
                    </Statistic>
                    <Statistic color="orange">
                      <Statistic.Value>
                        {nAnon}
                      </Statistic.Value>
                      <Statistic.Label>
                        {
                          nAnon > 1
                            ? 'Anonymes' : 'Anonyme'
                        }
                      </Statistic.Label>
                    </Statistic>
                    <Statistic color="grey">
                      <Statistic.Value>
                        {nPrereg > 0 ? '+' : ''}{nPrereg}
                      </Statistic.Value>
                      <Statistic.Label>
                        {nPrereg > 1 ? 'Préinscrits' : 'Préinscrit'}
                      </Statistic.Label>
                    </Statistic>
                  </Statistic.Group>
                </Segment>
                <Message attached info>
                  <Message.Header>Information sur le mode de comptage</Message.Header>
                  Seuls les utilisateurs ayant sélectionné cette {this.getThemeTypeLabel()} dans l'application mobile
                  sont comptabilisés ici. Certains utilisateurs peuvent être habilités à recevoir les messages de cette
                  &nbsp;{this.getThemeTypeLabel()} mais ne les reçoivent pas car ils ont séléctionné une autre
                  &nbsp;{this.getThemeTypeLabel()}.<br /><br />
                  Pour avoir une vision d'ensemble, rendez-vous dans l'onglet&nbsp;
                  <Link to="/recipients/list">
                    Gestion des destinataires
                  </Link>.
                </Message>
                <Segment>
                  <Header size="small">{'Destinataires actuels'.toUpperCase()}</Header>
                  <List
                    selection
                    divided
                    size="small"
                  >
                    {_.map(_.sortBy(this.state.recipients, u => u.email), (i) => {
                      if (!i.email) {
                        return null;
                      }
                      return (
                        <List.Item
                          icon="user"
                          key={i.key}
                          content={getUserLabelContent(i.email)}
                          onClick={() => this.props.history.push(`/recipients/edit/${i.key}`)}
                        />
                      );
                    })}
                    {this.state.recipients.length === 0 ?
                      (
                        <List.Item key="no_user">
                          Aucun utilisateur ne semble être destinataire des messages de cette {this.getThemeTypeLabel()}
                        </List.Item>
                      ) : null}
                    {nAnon > 0 ? (
                      <List.Item
                        key="anons"
                        icon="users"
                        content={`+ ${nAnon} utilisateurs anonymes`.toUpperCase()}
                      />
                    ) : null}
                  </List>
                </Segment>
                <Segment loading={!this.state.listenersLoading && this.state.preregListenerLoading}>
                  <Header size="small">
                    {`Préinscriptions pour cette ${this.getThemeTypeLabel()}`.toUpperCase()}
                  </Header>
                  <List
                    selection
                    divided
                    size="small"
                  >
                    {_.map(_.sortBy(this.state.preregistrations, u => atob(u.key)), (i) => {
                      const email = atob(i.key);
                      if (!email) {
                        return null;
                      }
                      return (
                        <List.Item
                          icon="user outline"
                          key={i.key}
                          content={getUserLabelContent(email)}
                          onClick={() => this.props.history.push('/recipients/preregistrations')}
                        />
                      );
                    })}
                    {this.state.preregistrations.length === 0 ?
                      (
                        <List.Item key="no_user">
                          Aucune préinscription en attente pour cette {this.getThemeTypeLabel()}
                        </List.Item>
                      ) : null}
                  </List>
                </Segment>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column>
              <Grid.Row>
                <Segment secondary>
                  <Header content="Ajouter des destinataires" />
                  <Message>
                    <p>
                      Saisissez les adresses email des personnes que vous souhaitez rendre destinataire des messages de
                      cette {this.getThemeTypeLabel()} : une adresse email par ligne, sans séparateur,
                      maximum {maxLines} lignes au total.
                    </p>
                    <p>
                      Cliquez ensuite sur "Vérifier".
                    </p>
                  </Message>
                  <Form error={notGoodToSend.length > 0}>
                    <Form.Field>
                      <Label
                        attached="top right"
                        content={`${this.state.lines}/${maxLines}`}
                        color={this.state.lines > maxLines ? 'red' : null}
                      />
                      <TextArea
                        // eslint-disable-next-line quotes
                        placeholder={"premier.utilisateur@exemple.fr\nsecond.utilisateur@exemple.fr\n..."}
                        style={{ minHeight: 100 }}
                        onChange={(e, { value }) => {
                          this.fields.emailBlock = value;
                          this.setState({ verified: false, lines: value.split('\n').length });
                        }}
                      />
                    </Form.Field>
                    <Grid columns={2}>
                      <Grid.Column>
                        <Button
                          content="Vérifier"
                          fluid
                          icon="search"
                          labelPosition="left"
                          disabled={this.state.verified}
                          onClick={this.handleAddCheck}
                        />
                      </Grid.Column>
                      <Grid.Column>
                        <Button
                          content="Valider"
                          fluid
                          icon="check"
                          labelPosition="right"
                          color="green"
                          loading={this.state.adding}
                          disabled={
                            !this.state.verified
                            || this.state.adding
                            || goodToSend.length < 1
                            || notGoodToSend.length > 0
                          }
                          onClick={this.handleAddSubmit}
                        />
                      </Grid.Column>
                    </Grid>
                    {notGoodToSend.length > 0 ? (
                      <Message error>
                        <Message.Header>
                          {notGoodToSend.length === 1
                            ? 'La ligne suivante ne correspond pas à une adresse email valide :'
                            : 'Les lignes suivantes ne sont pas des adresses email valides :'}
                        </Message.Header>
                        <Message.List>
                          {
                            _.map(notGoodToSend, i => (
                              <Message.Item key={i.l}>Ligne {i.l} : "{i.v}"</Message.Item>
                            ))
                          }
                        </Message.List>
                        <p>
                          Veuillez corriger ou retirer {notGoodToSend.length === 1 ? 'cette ligne'
                          : 'les lignes en erreur'}
                        </p>
                      </Message>
                    ) : null}
                    {goodToSend.length > 0 && notGoodToSend.length === 0 ? (
                      <Message info>
                        <p>
                          {goodToSend.length === 1 && 'Une adresse email valide trouvée'}
                          {goodToSend.length > 1 && `${goodToSend.length} adresses email valides trouvées`}
                        </p>
                        <p>
                          Vous pouvez cliquer sur "<strong>Valider</strong>" pour simuler l'ajout de ces destinataires.
                          <br />
                          Vous aurez alors un aperçu des utilisateurs pouvant être directement abonnés ou préinscrits à
                          cette {this.getThemeTypeLabel()}.<br />
                          Veuillez noter qu'il n'est pas possible d'abonner ou préinscrire un utilisateur si celui-ci
                          est déjà abonné ou préinscrit à une autre {this.getThemeTypeLabel()}.
                        </p>
                      </Message>
                    ) : null}

                  </Form>
                </Segment>
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </Segment>
        <AlertBox
          propagateClosure={() => this.setState({ alert: { open: false } })}
          {...this.state.alert}
        />
        <ConfirmBox
          propagateClosure={() => this.setState({ confirm: { open: false } })}
          {...this.state.confirm}
        />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/_common/ListRecipients.js